// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import type { IntlShape } from 'react-intl';

import type { MediaEngine } from 'state/types';
import localizedStrings from 'util/localizedStrings';

type Props = {
  index: number,
  intl: IntlShape,
  isMediaEngineTestPending: boolean,
  isSelected: boolean,
  mediaEngine: MediaEngine,
  onClickActive: MediaEngine => void,
  onClickRow: (SyntheticMouseEvent<>, number) => void,
  onClickTest: MediaEngine => void,
};

export default class MediaEngineRow extends Component<Props> {
  handleClickActive: Function;
  handleClickRow: Function;
  handleClickTest: Function;

  constructor() {
    super();
    this.handleClickActive = this.handleClickActive.bind(this);
    this.handleClickRow = this.handleClickRow.bind(this);
    this.handleClickTest = this.handleClickTest.bind(this);
  }
  handleClickRow(e: SyntheticMouseEvent<>) {
    this.props.onClickRow(e, this.props.index);
  }
  handleClickActive() {
    this.props.onClickActive(this.props.mediaEngine);
  }
  handleClickTest() {
    this.props.onClickTest(this.props.mediaEngine);
  }
  render() {
    const { isMediaEngineTestPending, isSelected, mediaEngine } = this.props;
    const rowClassName = `has-pointer ${isSelected ? 'is-selected' : ''}`;
    const radioClassName = `is-checkradio is-medium ${
      isSelected ? ' has-background-color is-white' : ''
    }`;
    const testClassName = `button is-small ${
      isMediaEngineTestPending && isSelected ? 'is-loading' : ''
    }`;
    return (
      <tr
        className={rowClassName}
        onClick={this.handleClickRow}
        style={{ verticalAlign: 'middle' }}
      >
        <td>
          <input
            className={radioClassName}
            data-test-name={`me-active-checkbox-${mediaEngine.id}`}
            id={`active-${mediaEngine.id}`}
            type="checkbox"
            checked={mediaEngine.enabled}
            onChange={this.handleClickActive}
          />
          <label htmlFor={`active-${mediaEngine.id}`} />
        </td>
        <td
          style={{ verticalAlign: 'middle' }}
          data-test-name={`me-address-${mediaEngine.id}`}
        >
          {mediaEngine.address}:{mediaEngine.port}
        </td>
        <td>
          <button
            className={testClassName}
            data-test-name={`me-test-${mediaEngine.id}`}
            disabled={isMediaEngineTestPending}
            onClick={this.handleClickTest}
          >
            <FormattedMessage {...localizedStrings.MEDIA_ENGINES_COLUMN_TEST} />
          </button>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/GlobalSettingsPages/MediaEngineRow.js